/**
 * Natural Language Query Service
 */
import apiClient from './apiClient';
import { QueryResult, ConversationItem, FeedbackType } from '../types';

export const queryService = {
  /**
   * Submit feedback for a response
   */
  async submitFeedback(
    question: string,
    answer: string | undefined,
    feedback: FeedbackType,
    options?: { comment?: string; conversationIndex?: number; conversationId?: string; messageId?: string }
  ): Promise<{ success: boolean; message?: string; error?: string }> {
    try {
      const response = await apiClient.post<{ success: boolean; message?: string; error?: string }>(
        '/feedback',
        {
          question,
          answer,
          feedback,
          comment: options?.comment,
          conversationIndex: options?.conversationIndex,
          conversationId: options?.conversationId,
          messageId: options?.messageId,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error('Error submitting feedback:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to submit feedback',
      };
    }
  },

  /**
   * Ask a natural language question
   */
  async askQuestion(
    question: string,
    conversationHistory: ConversationItem[] = [],
    conversationId?: string
  ): Promise<QueryResult> {
    try {
      const response = await apiClient.post<QueryResult>('/chat', {
        question,
        conversationId: conversationId || undefined,
        conversationHistory: conversationHistory.slice(-5).map((item) => ({
          question: item.question,
          daxQuery: item.daxQuery,
          answer: item.answer,
        })),
      });

      return response.data;
    } catch (error: any) {
      console.error('Error asking question:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to process your question. Please try again.',
      };
    }
  },

  /**
   * Get Power BI model metadata
   */
  async getMetadata(): Promise<any> {
    try {
      const response = await apiClient.get('/metadata');
      return response.data;
    } catch (error) {
      console.error('Error fetching metadata:', error);
      throw error;
    }
  },
};
